import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';
import { cn } from '@/lib/utils';

/* 狀態徽章：色票沿用舊版的語意色（成功綠 / 警告黃 / 資訊藍 / 危險紅）。 */
const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-[5px] px-2 py-0.5 text-[11.5px] font-semibold whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'bg-secondary text-foreground',
        success: 'bg-success-soft text-success-on',
        warn: 'bg-warn-soft text-warn-on',
        info: 'bg-info-soft text-info-on',
        danger: 'bg-accent text-accent-foreground',
        muted: 'bg-secondary text-muted-foreground',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
